import { NbMenuItem } from "@nebular/theme";
import { Type } from "@angular/core";
import { CmsComponentConfig } from './dynamic-component-container/dynamic-model';
import { Relation } from '@urbannex/view-containers';
import { OfbizForm } from "@urbannex/ofbiz-forms";

export interface Content {
    contentId: string;
    contentTypeId: string;
    ownerContentId: string;
    decoratorContentId: string;
    instanceOfContentId: string;
    dataResourceId: string;
    templateDataResourceId: string;
    dataSourceId: string;
    statusId: string;
    privilegeEnumId: string;
    serviceName: string;
    customMethodId: string;
    contentName: string;
    description: string;
    localeString: string;
    mimeTypeId: string;
    characterSetId: string;
    childLeafCount: string;
    childBranchCount: string;
    createdDate: string;
    createdByUserLogin: string;
    lastModifiedDate: string;
    lastModifiedByUserLogin: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ContentType {
    contentTypeId: string;
    parentTypeId: string;
    hasTable: string;
    description: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface DataResource {
    dataResourceId: string;
    dataResourceTypeId: string;
    dataTemplateTypeId: string;
    dataCategoryId: string;
    dataSourceId: string;
    statusId: string;
    dataResourceName: string;
    localeString: string;
    mimeTypeId: string;
    characterSetId: string;
    objectInfo: string;
    surveyId: string;
    surveyResponseId: string;
    relatedDetailId: string;
    isPublic: string;
    createdDate: string;
    createdByUserLogin: string;
    lastModifiedDate: string;
    lastModifiedByUserLogin: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface StatusItem {
    statusId: string;
    statusTypeId: string;
    statusCode: string;
    sequenceId: string;
    description: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface Enumeration {
    enumId: string;
    enumTypeId: string;
    enumCode: string;
    sequenceId: string;
    description: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface MimeType {
    mimeTypeId: string;
    description: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface DataSource {
    dataSourceId: string;
    dataSourceTypeId: string;
    description: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ContentAssocDataResourceViewFrom {
    contentIdStart: string;
    ownerContentId: string;
    contentId: string;
    contentTypeId: string;
    description: string;
    mimeTypeId: string;
    childLeafCount: string;
    privilegeEnumId: string;
    dataSourceId: string;
    lastModifiedByUserLogin: string;
    dataResourceId: string;
    createdByUserLogin: string;
    templateDataResourceId: string;
    lastModifiedDate: string;
    instanceOfContentId: string;
    serviceName: string;
    customMethodId: string;
    characterSetId: string;
    contentName: string;
    createdDate: string;
    statusId: string;
    localeString: string;
    decoratorContentId: string;
    childBranchCount: string;
    caSequenceNum: string;
    caLastModifiedDate: string;
    caContentIdTo: string;
    caUpperCoordinate: string;
    caLeftCoordinate: string;
    caContentId: string;
    caMapKey: string;
    caThruDate: string;
    caFromDate: string;
    caContentAssocPredicateId: string;
    caDataSourceId: string;
    caLastModifiedByUserLogin: string;
    caCreatedDate: string;
    caContentAssocTypeId: string;
    caCreatedByUserLogin: string;
    drDataResourceName: string;
    drSurveyId: string;
    drDataTemplateTypeId: string;
    drLastModifiedDate: string;
    drMimeTypeId: string;
    drDataCategoryId: string;
    drSurveyResponseId: string;
    drCharacterSetId: string;
    drDataSourceId: string;
    drLastModifiedByUserLogin: string;
    drCreatedDate: string;
    drStatusId: string;
    drLocaleString: string;
    drRelatedDetailId: string;
    drDataResourceId: string;
    drIsPublic: string;
    drObjectInfo: string;
    drDataResourceTypeId: string;
    drCreatedByUserLogin: string;
}

export interface ContentAssocDataResourceViewTo {
    contentIdStart: string;
    caSequenceNum: string;
    caLastModifiedDate: string;
    caContentIdTo: string;
    caUpperCoordinate: string;
    caLeftCoordinate: string;
    caContentId: string;
    caMapKey: string;
    caThruDate: string;
    caFromDate: string;
    caContentAssocPredicateId: string;
    caDataSourceId: string;
    caLastModifiedByUserLogin: string;
    caCreatedDate: string;
    caContentAssocTypeId: string;
    caCreatedByUserLogin: string;
    ownerContentId: string;
    contentId: string;
    contentTypeId: string;
    description: string;
    mimeTypeId: string;
    childLeafCount: string;
    privilegeEnumId: string;
    dataSourceId: string;
    lastModifiedByUserLogin: string;
    dataResourceId: string;
    createdByUserLogin: string;
    templateDataResourceId: string;
    lastModifiedDate: string;
    instanceOfContentId: string;
    serviceName: string;
    customMethodId: string;
    characterSetId: string;
    contentName: string;
    createdDate: string;
    statusId: string;
    localeString: string;
    decoratorContentId: string;
    childBranchCount: string;
    drDataResourceName: string;
    drSurveyId: string;
    drDataTemplateTypeId: string;
    drLastModifiedDate: string;
    drMimeTypeId: string;
    drDataCategoryId: string;
    drSurveyResponseId: string;
    drCharacterSetId: string;
    drDataSourceId: string;
    drLastModifiedByUserLogin: string;
    drCreatedDate: string;
    drStatusId: string;
    drLocaleString: string;
    drRelatedDetailId: string;
    drDataResourceId: string;
    drIsPublic: string;
    drObjectInfo: string;
    drDataResourceTypeId: string;
    drCreatedByUserLogin: string;
}

export interface ContentAssoc {
    contentId: string;
    contentIdTo: string;
    contentAssocTypeId: string;
    fromDate: string;
    thruDate: string;
    contentAssocPredicateId: string;
    dataSourceId: string;
    sequenceNum: string;
    mapKey: string;
    upperCoordinate: string;
    leftCoordinate: string;
    createdDate: string;
    createdByUserLogin: string;
    lastModifiedDate: string;
    lastModifiedByUserLogin: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ContentMetaData {
    contentId: string;
    metaDataPredicateId: string;
    metaDataValue: string;
    dataSourceId: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ContentRole {
    contentId: string;
    partyId: string;
    roleTypeId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

//Linked content
export interface CustRequestContent {
    custRequestId: string;
    contentId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface FacilityContent {
    facilityId: string;
    contentId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface InvoiceContent {
    invoiceId: string;
    invoiceContentTypeId: string;
    contentId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface OrderContent {
    orderId: string;
    orderItemSeqId: string;
    contentId: string;
    orderContentTypeId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface PartyContent {
    partyId: string;
    contentId: string;
    partyContentTypeId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ProdConfItemContent {
    configItemId: string;
    contentId: string;
    confItemContentTypeId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ProductCategoryContent {
    productCategoryId: string;
    contentId: string;
    prodCatContentTypeId: string;
    fromDate: string;
    thruDate: string;
    purchaseFromDate: string;
    purchaseThruDate: string;
    useCountLimit: string;
    useDaysLimit: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ProductContent {
    productId: string;
    contentId: string;
    productContentTypeId: string;
    fromDate: string;
    thruDate: string;
    purchaseFromDate: string;
    purchaseThruDate: string;
    useCountLimit: string;
    useTime: string;
    useTimeUomId: string;
    useRoleTypeId: string;
    sequenceNum: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ProductPromoContent {
    productPromoId: string;
    contentId: string;
    productPromoContentTypeId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface WebSiteContent {
    webSiteId: string;
    contentId: string;
    webSiteContentTypeId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface WorkEffortContent {
    workEffortId: string;
    contentId: string;
    workEffortContentTypeId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface SurveyResponseAnswer {
    surveyResponseId: string;
    surveyQuestionId: string;
    surveyMultiRespColId: string;
    surveyMultiRespId: string;
    booleanResponse: string;
    currencyResponse: string;
    floatResponse: string;
    numericResponse: string;
    textResponse: string;
    surveyOptionSeqId: string;
    contentId: string;
    answeredDate: string;
    amountBase: string;
    amountBaseUomId: string;
    weightFactor: string;
    duration: string;
    durationUomId: string;
    sequenceNum: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface Survey {
    surveyId: string;
    surveyName: string;
    description: string;
    comments: string;
    submitCaption: string;
    responseService: string;
    isAnonymous: string;
    allowMultiple: string;
    allowUpdate: string;
    acroFormContentId: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface DataCategory {
    dataCategoryId: string;
    parentCategoryId: string;
    categoryName: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface SurveyResponse {
    surveyResponseId: string;
    surveyId: string;
    partyId: string;
    responseDate: string;
    lastModifiedDate: string;
    referenceId: string;
    generalFeedback: string;
    orderId: string;
    orderItemSeqId: string;
    statusId: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface SurveyMultiResp {
    surveyId: string;
    surveyMultiRespId: string;
    multiRespTitle: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ProductStoreFinActSetting {
    productStoreId: string;
    finAccountTypeId: string;
    requirePinCode: string;
    validateGCFinAcct: string;
    accountCodeLength: string;
    pinCodeLength: string;
    accountValidDays: string;
    authValidDays: string;
    purchaseSurveyId: string;
    purchSurveySendTo: string;
    purchSurveyCopyMe: string;
    allowAuthToNegative: string;
    minBalance: string;
    replenishThreshold: string;
    replenishMethodEnumId: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ProductStoreSurveyAppl {
    productStoreSurveyId: string;
    productStoreId: string;
    surveyApplTypeId: string;
    groupName: string;
    surveyId: string;
    productId: string;
    productCategoryId: string;
    fromDate: string;
    thruDate: string;
    surveyTemplate: string;
    resultTemplate: string;
    sequenceNum: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}
export interface SurveyQuestionAppl {
    surveyId: string;
    surveyQuestionId: string;
    fromDate: string;
    thruDate: string;
    surveyPageSeqId: string;
    surveyMultiRespId: string;
    surveyMultiRespColId: string;
    requiredField: string;
    sequenceNum: string;
    externalFieldRef: string;
    withSurveyQuestionId: string;
    withSurveyOptionSeqId: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface WorkEffortSurveyAppl {
    workEffortId: string;
    surveyId: string;
    fromDate: string;
    thruDate: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface SurveyQuestion {
    surveyQuestionId: string;
    surveyQuestionCategoryId: string;
    surveyQuestionTypeId: string;
    description: string;
    question: string;
    hint: string;
    enumTypeId: string;
    geoId: string;
    formatString: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface SurveyQuestionOption {
    surveyQuestionId: string;
    surveyOptionSeqId: string;
    description: string;
    sequenceNum: string;
    amountBase: string;
    amountBaseUomId: string;
    weightFactor: string;
    duration: string;
    durationUomId: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}
export interface SurveyQuestionType {
    surveyQuestionTypeId: string;
    description: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}
export interface SurveyQuestionCategory {
    surveyQuestionCategoryId: string;
    parentCategoryId: string;
    description: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}
export interface SurveyResponseAnswer {
    surveyResponseId: string;
    surveyQuestionId: string;
    surveyMultiRespColId: string;
    surveyMultiRespId: string;
    booleanResponse: string;
    currencyResponse: string;
    floatResponse: string;
    numericResponse: string;
    textResponse: string;
    surveyOptionSeqId: string;
    contentId: string;
    answeredDate: string;
    amountBase: string;
    amountBaseUomId: string;
    weightFactor: string;
    duration: string;
    durationUomId: string;
    sequenceNum: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface Geo {
    geoId: string;
    geoTypeId: string;
    geoName: string;
    geoCode: string;
    geoSecCode: string;
    abbreviation: string;
    wellKnownText: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

//Linked dataResources

export interface AudioDataResource {
    dataResourceId: string;
    audioData: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}
export interface ElectronicText {
    dataResourceId: string;
    textData: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface ImageDataResource {
    dataResourceId: string;
    imageData: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface VideoDataResource {
    dataResourceId: string;
    videoData: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface DataResourceType {
    dataResourceTypeId: string;
    parentTypeId: string;
    hasTable: string;
    description: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface WebSiteContentType {
    webSiteContentTypeId: string;
    description: string;
    parentTypeId: string;
    hasTable: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
}

export interface WebSite {
    webSiteId: string;
    siteName: string;
    httpHost: string;
    httpPort: string;
    httpsHost: string;
    httpsPort: string;
    enableHttps: string;
    standardContentPrefix: string;
    secureContentPrefix: string;
    cookieDomain: string;
    visualThemeSetId: string;
    lastUpdatedStamp: string;
    lastUpdatedTxStamp: string;
    createdStamp: string;
    createdTxStamp: string;
    productStoreId: string;
    allowProductStoreChange: string;
}

export interface Image {
    contentId:string;
    dataResourceId:string;
}

export interface CmsState {
    workSpaceState:WorkSpaceState;
    callState:CallState;
    webSitesState?:WebSitesState;
    contentState?:ContentState;
    dataResourceState?:DataResourceState;
    surveyState?:SurveyState;
    galleryState?:GalleryState;
    blogState?:BlogState;
    firstVisit?:Boolean;
    action?:ActionState;
    cmsComponentConfig?:CmsComponentConfig;
    selectedValue?:any;
}

export interface WebSitesState {
    webSites:WebSite[];
    activeSelection:WebSite;
    actionState:ActionState;
}

export interface ContentState {
    contentList:Content[];
    activeSelection:Content;
    actionState:ActionState;
}

export interface DataResourceState {
    dataResourceList:DataResource[];
    activeSelection:DataResource;
    actionState:ActionState;
}

export interface SurveyState {
    surveys:Survey[];
    activeSelection:Survey;
    actionState:ActionState;
}

export interface GalleryState {
    imageList:Image[];
    activeSelection:Content;
    actionState:ActionState;
}

export interface Blog {
	blogContentId:string;
	contentName?:string;
	blogEntries?:BlogEntry[];
    blogEntry?:BlogEntry;
}

export interface BlogEntry {
	contentId:string;
	contentName?:string;
	description?:string;
    articleContentId?:string;
    statusId?:string;
    imageContentId?:string;
    summaryContentId?:string;
    articleData?:string;		
}

export interface BlogState {
    blogList?:Blog[];
    selectedBlog?:Blog;
    blogEntries?:BlogEntry[];
    activeSelection?:BlogEntry;
    actionState:ActionState;
}

export enum LoadingState {
    INIT = "INIT",
    LOADING = "LOADING",
    LOADED = "LOADED"
}

export interface ErrorState {
    errorMsg: string;
}

export enum ActionState {
    FIND = "find",
    ADD = "add",
    EDIT = "edit",
    DELETE = "delete",
    LIST = "list",
    VIEW = "view",
    TEST = "test",
}
//Values equal menu titles
export enum WorkSpaceState {
    WEBSSITES = "Websites",
    CONTENT = "Content",
    DATARESOURCE = "Data Resource",
    SURVEY = "Survey",
    BLOG = "Blog"
}

export type CallState = LoadingState | ErrorState;

export const DEFAULT_STATE: CmsState = {
    workSpaceState:WorkSpaceState.WEBSSITES,
    callState:LoadingState.INIT,
    firstVisit:true,
    action:ActionState.TEST,
    cmsComponentConfig:null,
    selectedValue:null,
}

export class CmsDynamicComponent {
    constructor(public component: Type<any>, public state?: Type<any>,public data?: any){
    }
}

export const enum SelectedSetup {
    MimeType = "MIMETYPE",
    ContentType = "CONTENTTYPE",
    WebSiteContentType = "WEBSITECONTENTTYPE",
    DataResourceType = "DATARESOURCETYPE",
    ContentAssocType = "CONTENTASSOCTYPE"
}



/* export const MENU_ITEMS:NbMenuItem[] = [
    {
        title: 'Websites',
        icon: 'globe-outline',
        link: '/admin/cms/websites',
        home: true,
      },
      {
        title: 'Content',
        icon: 'file-text-outline',
        link: '/admin/cms/content',
        home: true,
      },
      {
        title: 'Survey',
        icon: 'clipboard-outline',
        link: '/admin/cms/survey',
      },
      {
        title: 'Blogs',
        icon: 'book-outline',
        link: '/admin/cms/blog',
      },
      {
        title: 'Forum',
        icon: 'people-outline',
        link: '/admin/cms/forums',
      },
      {
        title: 'Data Resource',
        icon: 'cube-outline',
        link: '/admin/cms/data-resource',
      },
      {
        title: 'Gallery',
        icon: 'color-palette-outline',
        link: '/pages/iot-dashboard',
      },
      {
        title: 'Editors',
        icon: 'text-outline',
        children: [
          {
            title: 'TinyMCE',
            link: '/pages/editors/tinymce',
          },
          {
            title: 'CKEditor',
            link: '/pages/editors/ckeditor',
          },
        ],
      },
      {
        title: 'Tables & Data',
        icon: 'grid-outline',
        children: [
          {
            title: 'Smart Table',
            link: '/pages/tables/smart-table',
          },
          {
            title: 'Tree Grid',
            link: '/pages/tables/tree-grid',
          },
        ],
      },
] */

/* export const ContentRelations:Relation[] = [
  {
    title:"Associations From",
    entityName:"ContentAssoc",
    keyMap:{fieldName:"contentId"},
    addFormName:"AddContentAssoc",
    listFormName:"ListContentAssocFrom",
    
  },
  {
    title:"Associations To",
    entityName:"ContentAssoc",
    keyMap:{fieldName:"contentId",relatedFieldName:"contentId"},
    addFormName:"AddContentAssoc",
    listFormName:"ListContentAssocTO"
  },
  {
    title:"Content Roles",
    entityName:"ContentRole",
    keyMap:{fieldName:"contentId"},
    addFormName:"AddContentRole",
    listFormName:"ListContentRole",
  }
]
export const RELATIONS = {
  contentRelations:ContentRelations
} */

export const SETTINGS:any[] = [
    {
    title :"Content Type",
    entityName:"ContentType",
    addFormOptions:{
      formName:"AddContentType",
      entityName:"ContentType",
      formLocation:"component://content/widget/contentsetup/ContentSetupForms.xml",
    },
    listFormOptions:{
      fieldFormName:"FindContentType",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListContentType",
      entityName:"ContentType",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindContentType",
      viewIndex:1,
      actions:{
        position:'right',
        delete:false,
      }
    }
  },
  {
    title : "Content Purpose Type",
    entityName : "ContentPurposeType",
    "addFormOptions":{
      formName : "AddContentPurposeType",
      entityName:"ContentPurposeType",
      formLocation:"component://content/widget/contentsetup/ContentSetupForms.xml",
    },
    "listFormOptions":{
      fieldFormName:"FindContentPurposeType",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListContentPurposeType",
      entityName:"ContentPurposeType",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindContentPurposeType",
      viewIndex:1
    }
  },
  {
    "title":"Content Purpose Operation",
    "entityName":"ContentPurposeOperation",
    "addFormOptions":{
      formName:"AddContentPurposeOperation",
      entityName:"ContentPurposeOperation",
      formLocation:"component://content/widget/contentsetup/ContentSetupForms.xml",
    },
    "listFormOptions":{
      fieldFormName:"FindContentPurposeOperation",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListContentPurposeOperation",
      entityName:"ContentPurposeOperation",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindContentPurposeOperation",
      viewIndex:1
    }
  },
  {
    "title":"Content Operation",
    "entityName":"ContentOperation",
    "addFormOptions":{
      formName:"AddContentOperation",
      entityName:"ContentOperation",
      formLocation:"component://content/widget/contentsetup/ContentSetupForms.xml",
    },
    "listFormOptions":{
      fieldFormName:"FindContentOperation",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListContentOperation",
      entityName:"ContentOperation",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindContentOperation",
      viewIndex:1
    }
  },
  {
    "title":"Content Assoc Type",
    "entityName":"ContentAssocType",
    "addFormOptions":{
      formName:"AddContentAssocType",
      entityName:"ContentAssocType",
      formLocation:"component://content/widget/contentsetup/ContentSetupForms.xml",
    },
    "listFormOptions":{
      fieldFormName:"FindContentAssocType",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListContentAssocType",
      entityName:"ContentAssocType",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindContentAssocType",
      viewIndex:1
    }
  },
  {
    "title":"Content Assoc Predicate",
    "entityName":"ContentAssocPredicate",
    "addFormOptions":{
      formName:"AddContentAssocPredicate",
      entityName:"ContentAssocPredicate",
      formLocation:"component://content/widget/contentsetup/ContentSetupForms.xml",
    },
    "listFormOptions":{
      fieldFormName:"FindContentAssocPredicate",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListContentAssocPredicate",
      entityName:"ContentAssocPredicate",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindContentAssocPredicate",
      viewIndex:1
    }
  },
  {
    "title":"Content Type Attribute",
    "entityName":"ContentTypeAttr",
    "addFormOptions":{
      formName:"AddContentTypeAttr",
      entityName:"ContentTypeAttr",
      formLocation:"component://content/widget/contentsetup/ContentSetupForms.xml",
    },
    "listFormOptions":{
      fieldFormName:"FindContentTypeAttr",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListContentTypeAttr",
      entityName:"ContentTypeAttr",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindContentTypeAttr",
      viewIndex:1
    }
  },
  {
    "title":"Data Resource Type",
    "entityName":"DataResourceType",
    "addFormOptions":
      {
        formName:"AddDataResourceType",
        entityName:"DataResourceType",
        formLocation:"component://content/widget/datasetup/DataSetupForms.xml",
      },
    "listFormOptions":
      {
        fieldFormName:"FindDataResourceType",
        fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        listFormName:"ListDataResourceType",
        entityName:"DataResourceType",
        listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        endPoint:"listFindDataResourceType",
        viewIndex:1
      }
  },
  {
    "title":"Character Set",
    "entityName":"CharacterSet",
    "addFormOptions":{
      formName:"AddCharacterSet",
      entityName:"CharacterSet",
      formLocation:"component://content/widget/datasetup/DataSetupForms.xml",
    },
    "listFormOptions":
    {
      fieldFormName:"FindCharacterSet",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListCharacterSet",
      entityName:"CharacterSet",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindCharacterSet",
      viewIndex:1
    }
  },
  {
    "title":"Data Category",
    "entityName":"DataCategory",
    "addFormOptions":{
      formName:"AddDataCategory",
      entityName:"DataCategory",
      formLocation:"component://content/widget/datasetup/DataSetupForms.xml",
    },
    "listFormOptions":
    {
      fieldFormName:"FindDataCategory",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListDataCategory",
      entityName:"DataCategory",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindDataCategory",
      viewIndex:1
    }
  },
  {
    "title":"DataResource Type Attribute",
    "entityName":"DataResourceTypeAttr",
    "addFormOptions":{
      formName:"AddDataResourceTypeAttr",
      entityName:"DataResourceTypeAttr",
      formLocation:"component://content/widget/datasetup/DataSetupForms.xml",
    },
    "listFormOptions":
    {
      fieldFormName:"FindDataResourceTypeAttr",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListDataResourceTypeAttr",
      entityName:"DataResourceTypeAttr",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindDataResourceTypeAttr",
      viewIndex:1
    }
  },
  {
    "title":"File Extension",
    "entityName":"FileExtension",
    "addFormOptions":{
      formName:"AddFileExtension",
      entityName:"FileExtension",
      formLocation:"component://content/widget/datasetup/DataSetupForms.xml",
    },
    "listFormOptions":
    {
      fieldFormName:"FindFileExtension",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListFileExtension",
      entityName:"FileExtension",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindFileExtension",
      viewIndex:1
    }
  },
  {
    "title":"Meta Data Predicate",
    "entityName":"MetaDataPredicate",
    "addFormOptions":{
      formName:"AddFileExtension",
      entityName:"MetaDataPredicate",
      formLocation:"component://content/widget/datasetup/DataSetupForms.xml",
    },
    "listFormOptions":
    {
      fieldFormName:"FindMetaDataPredicate",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListMetaDataPredicate",
      entityName:"MetaDataPredicate",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindMetaDataPredicate",
      viewIndex:1
    }
  },
  {
    "title":"Mime Type",
    "entityName":"MimeType",
    "addFormOptions":{
      formName:"AddMimeType",
      entityName:"MimeType",
      formLocation:"component://content/widget/datasetup/DataSetupForms.xml",
    },
    "listFormOptions":
    {
      fieldFormName:"FindMimeType",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListMimeType",
      entityName:"MimeType",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindMimeType",
      viewIndex:1
    }
  },
  {
    "title":"Mime Type Html Template",
    "entityName":"MimeTypeHtmlTemplate",
    "addFormOptions":{
      formName:"CreateMimeTypeHtmlTemplate",
      entityName:"MimeTypeHtmlTemplate",
      formLocation:"component://content/widget/datasetup/DataSetupForms.xml",
    },
    "listFormOptions":
    {
      fieldFormName:"FindMimeTypeHtmlTemplate",
      fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      listFormName:"ListMimeTypeHtmlTemplate",
      entityName:"MimeTypeHtmlTemplate",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      endPoint:"listFindMimeTypeHtmlTemplate",
      viewIndex:1
    }
  },
    {
      "title":"Survey Question Type",
      "entityName":"SurveyQuestionType",
      "addFormOptions":{
        formName:"CreateSurveyQuestion",
        entityName:"SurveyQuestionType",
        formLocation:"component://content/widget/survey/SurveyForms.xml",
      },
      "listFormOptions":{
        fieldFormName:"FindSurveyQuestionType",
        fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        listFormName:"ListSurveyQuestionType",
        entityName:"SurveyQuestionType",
        listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        endPoint:"listFindSurveyQuestionType",
        viewIndex:1
      }
    },
    {
      "title":"Survey Appl Type",
      "entityName":"SurveyApplType",
      "addFormOptions":{
        formName:"AddSurveyApplType",
        entityName:"SurveyApplType",
        formLocation:"component://commonforms/widget/CommonFormsForms.xml",
      },
      "listFormOptions":{
        fieldFormName:"FindSurveyApplType",
        fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        listFormName:"ListSurveyApplType",
        entityName:"SurveyApplType",
        listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        endPoint:"listFindSurveyApplType",
        viewIndex:1
      }
    },
    {
      "title":"Survey Question Category",
      "entityName":"SurveyQuestionCategory",
      "addFormOptions":{
        formName:"CreateSurveyQuestionCategory",
        entityName:"SurveyQuestionCategory",
        formLocation:"component://content/widget/survey/SurveyForms.xml",
      },
      "listFormOptions":{
        fieldFormName:"FindSurveyQuestionCategory",
        fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        listFormName:"ListSurveyQuestionCategory",
        entityName:"SurveyQuestionCategory",
        listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        endPoint:"listFindSurveyQuestionCategory",
        viewIndex:1
      }
    },
    {
      "title":"WebSite Content Type",
      "entityName":"WebSiteContentType",
      "addFormOptions":{
        formName:"AddWebSiteContentType",
        entityName:"WebSiteContentType",
        formLocation:"component://commonforms/widget/CommonFormsForms.xml",
      },
      "listFormOptions":{
        fieldFormName:"FindWebSiteContentType",
        fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        listFormName:"ListWebSiteContentType",
        entityName:"WebSiteContentType",
        listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        endPoint:"listFindWebSiteContentType",
        viewIndex:1
      }
    }


]
    








